/* istanbul ignore file */
export const REQUEST_USER = 'REQUEST_USER'
export const RECEIVE_USER = 'RECEIVE_USER'
export const RECEIVE_LOGOUT = 'RECEIVE_LOGOUT'
export const UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR'
export const TRACK_ANALYTICS4_EVENT = 'TRACK_ANALYTICS4_EVENT'
export const UPDATE_DRIVER = 'UPDATE_DRIVER'
export const PUSH = 'PUSH'
export const NAVIGATE_TO = 'NAVIGATE_TO'
export const RELOAD = 'RELOAD'
export const RECEIVE_RATES = 'RECEIVE_RATES'
export const REQUEST_RATES = 'REQUEST_RATES'
export const SET_RATES = 'SET_RATES'
export const RECEIVE_RENTAL_CAR_CONTRACT = 'RECEIVE_RENTAL_CAR_CONTRACT'
export const REQUEST_RENTAL_CAR_CONTRACT = 'REQUEST_RENTAL_CAR_CONTRACT'
export const UNPROCESSABLE_ENTITY_ERROR = 'UNPROCESSABLE_ENTITY_ERROR'
export const SET_KEYCLOAK_TOKEN = 'SET_KEYCLOAK_TOKEN'
export const RECEIVE_BUILD_BOOKING = 'RECEIVE_BUILD_BOOKING'
export const REQUEST_BUILD_BOOKING = 'REQUEST_BUILD_BOOKING'
export const RECEIVE_UPDATE_BOOKING = 'RECEIVE_UPDATE_BOOKING'
export const REQUEST_UPDATE_BOOKING = 'REQUEST_UPDATE_BOOKING'
export const CONTRACT_RENTAL_CAR = 'CONTRACT_RENTAL_CAR'
